// extracted by mini-css-extract-plugin
export var aircallIframe = "_jk-3";
export var fabContainer = "_jk-5";
export var fabRinging = "_jk-6";
export var loadingOverlay = "_jk-4";
export var pulse = "_jk-7";
export var widgetContent = "_jk-2";
export var widgetPanel = "_jk-0";
export var widgetPanelExpanded = "_jk-1";